import './defines';
import * as DB from '@sosocio/creator-types/database';
import * as PI from '@sosocio/creator-types/project';
import ProgressBar from 'components/progress-bar';
import SpinnerComponent from 'components/spinner';
import {
	Component,
	toNative,
} from 'utils/vue-facing-decorator';
import {
	Prop,
	Vue,
	Watch,
} from 'vue-facing-decorator';
import Template from './template.vue';

@Component({
	components: {
		SpinnerComponent,
		ProgressBar,
	},
	emits: ['closeDialog'],
	mixins: [Template],
})
class FileConversionView extends Vue {
	@Prop({
		required: true,
		type: String,
	})
	public readonly offeringType!: DB.OfferingModel['type'];

	@Prop({
		required: true,
		type: Array,
	})
	public readonly photosProcessed!: PI.PhotoModel[];

	@Prop({
		required: true,
		type: Number,
	})
	public readonly progressPercentage!: number;

	@Prop({
		required: true,
		type: Number,
	})
	public readonly submittedCount!: number;

	@Watch('progressPercentage')
	protected autoClose() {
		if (this.progressPercentage >= 100) {
			this.$emit('closeDialog');
		}
	}
}

export default toNative(FileConversionView);
